var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "488.000000pt",
    height: "476.000000pt",
    viewBox: "0 0 488.000000 476.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,476.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4633 4735 c-61 -19 -99 -43 -220 -141 -849 -689 -1739 -1730 -2640 -3087 -113 -170 -206 -307 -208 -305 -1 2 -206 347 -454 768 -249 421 -466 780 -484 797 -98 103 -270 74 -424 -70 -119 -112 -193 -251 -193 -367 0 -67 -56 39 655 -1234 297 -532 554 -981 570 -998 17 -17 55 -42 85 -57 49 -23 67 -26 160 -26 78 1 126 7 185 23 90 26 293 123 373 180 53 37 54 39 141 237 739 1688 1506 2896 2517 3962 153 160 174 189 174 239 0 76 -119 116 -237 79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIcon);
export default __webpack_public_path__ + "static/media/CheckmarkIcon.b13b225e4f64ff308c6d13eb169eee8f.svg";
export { ForwardRef as ReactComponent };